<template lang="pug">
  .intro-screen#intro-screen
    .container
      .row
        .col-xs-12.col-md-8.col-md-offset-2.col-xl-6.col-xl-offset-3
          .intro
            img.intro__logo(src="../assets/logo.png" alt="Вилла Бланка")
            .intro__warning(v-if="!isDenied")
              p.intro__warning-text Добро пожаловать в мир Villa Blanca
              p.intro__warning-text Вам уже исполнилось 18 лет?
            
            .intro__bye-bye(v-if="isDenied") Извините, вы не можете зайти на сайт, так как представленная на сайте информация предназначена для лиц не моложе 18 лет.
            
            .intro__buttons(v-if="!isDenied")
              button.button.button--gradient.button--contrast.button--narrow(@click="$emit('allow-access')") Да
              button.button.button--gradient.button--contrast.button--narrow(@click="isDenied = !isDenied") Нет
            .intro__try-again
              button.button.button--gradient.button--contrast(@click="isDenied = !isDenied", v-if="isDenied") Попробовать еще раз
</template>

<script>
import Cookies from "js-cookie";
import Button from "./Button.vue";

export default {
  name: "Footer",
  components: {
    Button
  },
  data() {
    return {
      isDenied: false
    };
  }
};
</script>

<style lang="scss">
@import "../styles/main.scss";

.intro-screen {
  z-index: 2000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("~@/assets/intro-background.jpg") no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
}

.intro {
  width: 100%;
  background: $color-background;
  height: 361px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;

  &__logo {
    width: 60%;
    margin: auto;
    display: block;
    transform: translateY(-28%);
    min-height: 1px; // IE bugfix magic
  }
  &__warning {
    text-align: center;
    margin-bottom: 60px;
    padding: 0 20px;

    @include from("sm") {
      padding: 0;
    }
  }
  &__warning-text {
    font-weight: bold;
    font-size: 22px;
    margin: 0;
    line-height: 1.3;

    @include from("sm") {
      font-size: 30px;
    }
  }
  &__bye-bye {
    font-size: 20px;
    line-height: 1.2;
    text-align: center;
    padding: 0 60px;

    @include from("sm") {
      font-size: 24px;
    }
  }
  &__buttons {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    padding: 0 20px;
    box-sizing: border-box;
    transform: translateY(40%);

    .button--contrast {
      &:after {
        background: #fff;
        width: calc(100% - 4px * 1.5);
        height: calc(100% - 4px * 1.5);
        z-index: -1;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50px;
      }
    }
  }
  &__try-again {
    transform: translateY(40%);

    button {
      width: auto;
      font-size: 16px;
      padding: 25px 10px 23px;

      @include from("md") {
        font-size: 20px;
      }
    }
  }
}
</style>
